export default {
  companyName: "河南亿翔化工有限公司",
  companyNameEn: "Henan Yixiang Chemical Co., Ltd.",
  phone: " (+86) 187-333-78756",
  email: "info@yixiangchemical.com",
  address: "河南省郑州市金水区农科路16号11号楼29层2907号",
  addressEn:
    "No. 2907, 29th, Floor Building 11, No. 16 Nongke Road, Jinshui District, Zhengzhou City, Henan Porvince, China",
  websit: "www.yixiangchemical.com",
};

export function isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}

export const companyInfo = {
  p1: "Henan Yixiang Chemical Co., Ltd. was established in 2023 ， a professional chemical distributor in China, involved in solvents, petrochemicals, coating, resins and some other chemical goods. ",
  p2: "Yixiang Chemical is cooperating with leading global suppliers to ensure the high quality, efficiency, and safety of our products and services, while meeting the maximum needs of our customers.",
  p3: "Yixiang Chemical always seeks a win-win situation, actively establishing win-win cooperation with suppliers and downstream customers in daily business activities, and comprehensively promoting the establishment of a long-term, efficient, and mutually beneficial cooperation model.",
  p4: "The company adheres to the concept of one-stop service, providing customers with high-quality product supply, which has been highly praised in the industry and exported to domestic and foreign markets.",
  p5: "We will continue to never forget our original intention, bring the highest quality products and services to customers, provide them with a wonderful user experience, and create a better life with chemicals!",
};
